<template>
  <div>
    <v-snackbar
      v-for="(alert, index) in alerts"
      :key="alert.id"
      v-model="alert.show"
      :color="alert.color"
      :timeout="-1"
      location="bottom right"
      variant="flat"
      :style="{ 'margin-bottom': `${index * dynamicSpacing}px` }" 
    >
      <div class="text-white font-medium">
        {{ alert.message }}
      </div>

      <template #actions>
        <v-btn
          icon="mdi-close"
          size="small"
          variant="text"
          @click="removeAlert(alert.id)"
        />
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AppSnackbar',
  computed: {
    ...mapState('ui', ['alerts']),
    
    // Calcula o espaçamento com base no tamanho da tela
    dynamicSpacing() {
      // Se a tela for maior que 'md' (Computadores e Tablets deitados), retorna 50.
      if (this.$vuetify.display.mdAndUp) {
        return 50;
      }
      return 90;
    }
  },
  methods: {
    ...mapActions('ui', ['removeAlert'])
  }
}
</script>

<style scoped>
.v-snackbar {
  transition: margin-bottom 0.3s ease-in-out;
}
</style>